import { all, takeLatest } from 'redux-saga/effects'
import store from '../../store'
import { actions } from './WorkOrders.slice'
import { paginate } from './WorkOrders.thunk'

function paginateWorkOrders () {
  store.dispatch(paginate() as any)
}

export default function * effects () {
  yield all([
    takeLatest(actions.replaceLimit, paginateWorkOrders),
    takeLatest(actions.replacePage, paginateWorkOrders),
    takeLatest(actions.replaceSearch, paginateWorkOrders)
  ])
}
